import { UserOutlined } from "@ant-design/icons";

import { TextDOMPurify } from "Services/Sanitization";

import { escapeRegExp } from "../helper";

import styles from "./SpotlightUsersItem.module.scss";
type SpotlightUsersItemProps = {
    name: string;
    description: string;
    searchValue: string;
    onCallback: () => void;
    route?: string;
};

export function SpotlightUsersItem({
    name,
    description,
    searchValue,
    onCallback,
    route,
}: SpotlightUsersItemProps): JSX.Element {
    const highlightMatches = (text: string) => {
        // Escape special regex characters in searchValue
        const escapedSearchValue = escapeRegExp(searchValue);
        return text
            .split(new RegExp(`(${escapedSearchValue})`, "i"))
            .map((part, index) =>
                part.toLowerCase() === searchValue.toLowerCase()
                    ? `<em key=${index}>
                    ${part}
                </em>`
                    : `<span key=${index}>${part}</span>`
            )
            .join("");
    };
    return (
        <div className={styles.spotlightItem} data-route={route} onClick={onCallback}>
            <div>
                <UserOutlined />
            </div>
            <div>
                <div className={styles.routeContainer}>
                    <div
                        className={styles.name}
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: TextDOMPurify.sanitize(highlightMatches(name).toString()),
                        }}
                    ></div>
                </div>
                {description && (
                    <div
                        className={styles.description}
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: TextDOMPurify.sanitize(highlightMatches(description).toString()),
                        }}
                    ></div>
                )}
            </div>
        </div>
    );
}
